import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface RetirementTransactionState {
    data: [] | null | any;
    currentPage: number | null;
    totalRecords: number | null;
    totalPages: number | null;
    allRetirementTransaction: [] | null | any;
}

const initialState: RetirementTransactionState = {
    data: null,
    totalRecords: null,
    totalPages: null,
    currentPage: null,
    allRetirementTransaction: null,
};

export const retirementTransactionSlice = createSlice({
    name: 'RetirementTransaction',
    initialState,
    reducers: {
        setRetirementTransaction: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
            state.currentPage = action.payload.data?.currentPage;
        },
        setRetirementTransactionBySearch: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
            state.currentPage = action.payload.data?.currentPage;
        },
        setAllRetirementTransaction: (state, action) => {
            state.allRetirementTransaction = action.payload.data;
        },
        reset: (state) => {
            Object.assign(state, initialState);
        },
    },
});

export const { setRetirementTransaction, setRetirementTransactionBySearch, setAllRetirementTransaction, reset } = retirementTransactionSlice.actions;
export const getAllRetirementTransactionDetails = (state: RootState) => state.retirementTransaction.data;
export const getRetirementTransactionTotalRecords = (state: RootState) => state.retirementTransaction.totalRecords;
export const getAllRetirementTransactionBySearch = (state: RootState) => state.retirementTransaction.data;
export default retirementTransactionSlice.reducer;
